// ui components

import Select from "react-select";
import styled from "styled-components";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { RootState } from "../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { PermissionMenuName } from "../../interfaces/UserRole";
import { fieldErrorMessage, fieldHasErrors } from "../../store/errorHandler";
import { Option, getSelectedStatusOption, STATUS_OPTIONS, allowSave, allowDelete } from "../../store/helpers";
import { createStatusKerjasamaAsync, initializeCreateStatusKerjasama, updateStatusKerjasamaAsync, updateName, updateStatus, getDetailStatusKerjasamaAsync } from "../../reducers/statusKerjasama/statusKerjasama.actions";

export const StatusKerjasamaUpdatePage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isNew, setIsNew] = useState<boolean>(false);
  const errors = useSelector((state: RootState) => state.statusKerjasama.error);
  const isLoading = useSelector((state: RootState) => state.statusKerjasama.isLoading);
  const redirectQueue = useSelector((state: RootState) => state.statusKerjasama.redirectQueue);
  const statusKerjasama = useSelector((state: RootState) => state.statusKerjasama.selectedStatusKerjasama);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.masterData].ACCESS);

  const canSave = allowSave(role, 2);

  useEffect(() => {
    const paths = location.pathname.split("/");
    if (paths[2] === 'create') {
      setIsNew(true);
      dispatch(initializeCreateStatusKerjasama());
    } else {
      setIsNew(false);
      const id = parseInt(paths[2]);
      if (id && !isNaN(id)) {
        dispatch(getDetailStatusKerjasamaAsync.request({ id }));
      } else {
        history.push(`/status-kerjasama/create`);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (redirectQueue) {
      history.push(redirectQueue);
      dispatch(initializeCreateStatusKerjasama());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectQueue])

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateName(e.target.value));
  }

  const onChangeStatus = (e: Option | null) => {
    if (!e) return;
    if (isNaN(parseInt(e.value))) return;
    dispatch(updateStatus(parseInt(e.value)));
  }

  const save = () => {
    if (!statusKerjasama) return;
    if (isNew) {
      dispatch(createStatusKerjasamaAsync.request(statusKerjasama))
    } else {
      dispatch(updateStatusKerjasamaAsync.request(statusKerjasama))
    }
  }
 
  return (
    <StatusKerjasamaUpdatePageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-5">
            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">Detail Status Kerjasama</h3>
                <div className="box-tools">
                  <button
                    className="btn btn-primary"
                    style={{marginRight: '4px'}}
                    onClick={() => history.push('/status-kerjasama')}
                  >
                    kembali
                  </button>
                  <button
                    className="btn btn-primary"
                    disabled={isLoading || !canSave}
                    onClick={save}
                  >
                    Simpan
                  </button>
                </div>
              </div>
              <div className="box-body">
                <div className={`form-group ${fieldHasErrors('STATUS_NAME', errors) ? 'has-error' : ''}`}>
                  <label>Nama Status Kerjasama <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    onChange={onChangeName}
                    className='form-control'
                    disabled={isLoading || !canSave}
                    style={{ display: 'block', width: '100%' }}
                    defaultValue={statusKerjasama?.STATUS_NAME}
                  />
                  <span className="help-block">{ fieldErrorMessage('STATUS_NAME', errors) }</span>
                </div>
                <div className="form-group">
                  <label>Status <span className="text-red"><b>*</b></span></label>
                  <Select 
                    options={STATUS_OPTIONS}
                    onChange={onChangeStatus}
                    isDisabled={isLoading || !allowDelete(role, 2)}
                    value={getSelectedStatusOption(statusKerjasama?.STATUS)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </StatusKerjasamaUpdatePageWrapper>
  );
}

const StatusKerjasamaUpdatePageWrapper = styled.div``;